import React, { useState, useEffect } from "react";
import { IconButton, Drawer, Container, List, ListItemButton, Divider, darken, ListItemIcon, ListItemText, Menu, MenuItem } from "@mui/material";
import { IconMenu2, IconX, IconWorld, IconCheck } from "@tabler/icons-react";
import { useTranslation } from 'react-i18next';
import { Link as RouterLink, useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";

import { useScreenSize } from "@context/screenSizeContext";

import Logo from "@assets/logo/zhushan-horizontal-logo.png"

import "./header.css";

import { LANGUAGES } from "@utils/constant";

export default function Header({ routes }) {
  const isSmallScreen = useScreenSize();
  const { t, i18n } = useTranslation();
  const { pathname } = useLocation();
  const navigate = useNavigate()

  const [open, setOpen] = useState(false);  // navbar
  const [anchorEl, setAnchorEl] = useState(null);

  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(()=>{
    if(!isSmallScreen)
      setOpen(false)
  },[isSmallScreen])

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng); // Change the current language
    localStorage.setItem('i18nextLng', lng); // Save selected language to localStorage
    handleClose()
  };

  const renderNav = (isDrawer = false) => (
    <>
    {
      routes.map((data, index) => (
        <React.Fragment key={index}>
          {(data.highlight && !isDrawer) ? 
            <ListItemButton 
              LinkComponent={RouterLink}
              to={data?.path}
              onClick={()=>setOpen(false)}
              sx={{
                color: '#FFF', 
                backgroundColor: '#7CA7AD', 
                fontSize: isSmallScreen ? '16px' : '14px', 
                padding: '10px 30px', 
                borderRadius: '100px',
                ":hover": {
                  backgroundColor: darken("#7CA7AD", 0.15)
                },
              }}>
              {data.title}
            </ListItemButton>
            :
            <ListItemButton 
              LinkComponent={RouterLink}
              to={data?.path}
              onClick={()=>setOpen(false)}
              sx={{
                color: '#414042', 
                fontSize: isSmallScreen ? '16px' : '14px',
                padding: '10px 20px', 
                borderRadius: '5px'
              }}>
              {data.title}
            </ListItemButton>
          }
        </React.Fragment>
      ))
    }
    { 
      !isDrawer &&
        <ListItemButton 
          sx={{
            color: '#414042', 
            borderRadius: '5px',
            fontSize: isSmallScreen ? '16px' : '14px',
            padding: '10px 20px', 
            gap: '5px'
          }}
          onClick={handleClick}
        >
          <IconWorld size={16}/>
          {t('languageShort')}
        </ListItemButton>
    }
    </>
  )

  return (
    <>
      <header
        className={`header-container ${(isScrolled || pathname !== '/' || open)  ? "scrolled" : ""}`}
      >
        <Container 
          maxWidth="xl" 
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <img onClick={()=>navigate('/')} src={Logo} alt='Zhu Shan' className="logo"/>
          {isSmallScreen ?
            <IconButton onClick={() => setOpen(open === true ? false : true)}>
              { !open ? <IconMenu2 color="#5D5D5D" /> : <IconX color="#5D5D5D"/> }
            </IconButton> 
            :
            <List sx={{display: "flex", alignItems: "center", gap: "20px"}}>
              {renderNav()}
            </List>
          }
        </Container>
      </header>

      <Drawer open={open} onClose={() => setOpen(false)} anchor="left" hideBackdrop variant="persistent"
        sx={{
          "& .MuiDrawer-paper": {
            top: "75px",
            height: "calc(100vh - 75px);",
            width: "100%",
            boxShadow: 'none',
          },
        }}
      >
        <List sx={{display: "flex", flexDirection: 'column', gap: "10px", padding: "5px"}}>
          {renderNav(true)}
        </List>
        <div style={{ marginTop: 'auto', padding: "5px" }}>
          <Divider sx={{ backgroundColor: "#ffffff", margin: '0px 20px'}} />
          <List>
            <ListItemButton 
              sx={{
                color: '#414042', 
                borderRadius: '5px',
                padding: '10px 20px', 
                gap: '5px'
              }}
              onClick={handleClick}
            >
              <IconWorld size={22}/>
              <ListItemText primary={t('language')}/>
            </ListItemButton>
          </List>
        </div>
      </Drawer>

      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={!!anchorEl}
        onClose={handleClose}
      >
        {
          LANGUAGES.map((language, index)=>(
            <MenuItem onClick={()=>changeLanguage(language.code)} key={index}>
              {i18n.language === language.code &&
                <ListItemIcon>
                  <IconCheck size={20}/>
                </ListItemIcon>
              }
              <ListItemText inset={i18n.language !== language.code}>{language.name}</ListItemText>
            </MenuItem>
          ))
        }
      </Menu>
    </>
  );
}